module.exports = ":host ::ng-deep #instanceViewModal .modal-content .modal-body{\r\n    padding-top: 0;\r\n}"